import * as React from 'react'

import { TriangleAlertIcon } from 'lucide-react'
import { computed, makeObservable } from 'mobx'
import { inject, observer } from 'mobx-react'

import PhotoView from '~/client/src/mobile/views/Documents/components/PhotoGallery/components/Photo/Photo'
import PhotosStore from '~/client/src/shared/stores/domain/Photos.store'
import ProjectDateStore from '~/client/src/shared/stores/ui/ProjectDate.store'

import './PhotoGallery.scss'

const thereIsNoPhotoPassingFilters = 'There is no photo passing filters'

interface IPhotoGalleryProps {
  photosStore?: PhotosStore
  projectDateStore?: ProjectDateStore
}

@inject('photosStore', 'projectDateStore')
@observer
export default class PhotoGallery extends React.Component<IPhotoGalleryProps> {
  public constructor(props: IPhotoGalleryProps) {
    super(props)
    makeObservable(this)
  }

  public render() {
    return <div className="photo-gallery-component">{this.getViewByDate()}</div>
  }

  @computed
  private get photosByDate() {
    return this.props.photosStore.photosByDate
      .map(batch => ({
        date: batch.date,
        photos: batch.photos.filter(photo => !!photo.url),
      }))
      .filter(batch => batch.photos.length)
      .sort(this.byPhotoBatchDescendingDate)
  }

  private getDateHeader(date: Date): string {
    const { getPronoun, getMonthDayAndYearToDisplay } =
      this.props.projectDateStore
    const datePronoun = getPronoun(date)

    return (
      (datePronoun ? datePronoun + ', ' : '') +
      getMonthDayAndYearToDisplay(date)
    )
  }

  private getTitleClass(dateHeader: string) {
    return 'photo-gallery-date' + (dateHeader === 'Today' ? ' today' : '')
  }

  private readonly byPhotoBatchDescendingDate = (a, b) =>
    b.date.getTime() - a.date.getTime()

  private getViewByDate() {
    if (!this.photosByDate.length) {
      return this.renderNoPhotosMessage()
    }

    return this.photosByDate.map(batch => {
      const dateKey = batch.date.getTime()
      const dateHeader = this.getDateHeader(batch.date)
      const titleClass = this.getTitleClass(dateHeader) + ' section-title'

      return (
        <div className="photo-gallery-container" key={dateKey}>
          <div className={titleClass}>{dateHeader}</div>
          <div className="photo-gallery-photos">
            {batch.photos.map(photo => (
              <div key={photo.id}>
                <PhotoView width={60} height={80} photo={photo} />
              </div>
            ))}
          </div>
        </div>
      )
    })
  }

  private renderNoPhotosMessage() {
    return (
      <div className="col x-center y-center pt30">
        <div className="row">
          <TriangleAlertIcon size={20} className="warning-icon mr5" />
          {thereIsNoPhotoPassingFilters}
        </div>
      </div>
    )
  }
}
